import { useCallback, useMemo } from 'react';
import { useQuery, useMutation } from '@ts-core/lib/apollo';

import { updateThreadAnswerMutation } from '@ts-core/graphql/forum/mutations';

import { getThreadAnswerQuery } from '@ts-core/graphql/forum/queries';

import { useMutationCompletionHandler } from '@ts-core/lib/apollo';

export default function useThreadAnswer({ courseId, threadId, answerId, onThreadAnswerUpdated }) {
  const { onError } = useMutationCompletionHandler();

  /**
   * Get Thread Answer
   */
  const { data, loading } = useQuery(getThreadAnswerQuery, {
    variables: { courseId, threadId, answerId },
    skip: !courseId || !threadId || !answerId,
    fetchPolicy: 'cache-and-network',
  });
  const answer = useMemo(() => data?.threadAnswer, [data]);

  /**
   * Update Thread Answer
   */
  const [updateThreadAnswer, { loading: updatingThreadAnswer }] = useMutation(updateThreadAnswerMutation, {
    onError,
    onCompleted: onThreadAnswerUpdated,
  });
  const onUpdateThreadAnswer = useCallback(
    (input) => {
      updateThreadAnswer({
        variables: { courseId, threadId, answerId, input },
      });
    },
    [updateThreadAnswer, courseId, threadId, answerId]
  );

  return {
    answer,
    loading,

    onUpdateThreadAnswer,
    updatingThreadAnswer,
  };
}
